// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-button-class .p-button{padding:.5rem .8rem}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/charts/chart-wrapper/ChartWrapperStyle.scss"],"names":[],"mappings":"AACE,+BACE,mBAAA","sourcesContent":[".select-button-class {\n  .p-button {\n    padding: 0.5rem 0.8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
